/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { Partner_Partner as EmbeddedPartner } from '__generated__/graphql-types-do-not-use';

import { breakpoints } from '@coursera/cds-core';
import type { SectionName } from '@coursera/event-pulse-types';

import EmbeddedPartnersModalItem from 'bundles/unified-description-page-common/components/shared/modals/EmbeddedPartnersModalItem';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';

import _t from 'i18n!nls/xdp';

const styles = {
  container: css`
    column-count: 2;
    column-gap: var(--cds-spacing-600);
    ${breakpoints.down('sm')} {
      column-count: 1;
    }
  `,
  partner: css`
    display: flex;
    gap: var(--cds-spacing-400);
    align-items: start;
    ${breakpoints.down('sm')} {
      flex-direction: column;
    }
  `,
};

type Props = ModalProps & {
  partners: EmbeddedPartner[];
  trackingLocation?: SectionName;
  disableCTA?: boolean;
};

const EmbeddedPartnersModal = ({ partners, disableCTA, trackingLocation, ...rest }: Props) => {
  return (
    <Modal {...rest} header={_t('With content from')} width="large">
      <div css={styles.container}>
        {partners.map((partner) => (
          <div key={partner.id} css={styles.partner}>
            <EmbeddedPartnersModalItem partner={partner} disableCTA={disableCTA} trackingLocation={trackingLocation} />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default EmbeddedPartnersModal;
